// TODO: fix api dependency
export enum ProductType {
  CURRENT_ACCOUNT = '01',
  SAVING_ACCOUNT = '04',
  LOAN_ACCOUNT = '10',
  TDC_ACCOUNT = '94',
}
